module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Contents"
    }
  }, [_c('p', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('p', {
    staticClass: "tocfm"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/05_Acknowledgements"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_The_Home_Front"
    }
  }, [_vm._v("The Home Front")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Section01",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Section 1    The pre-war world")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Section02",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Section 2    Mobilisation, recruiting and departure")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Section03",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Section 3    Getting ready for war")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Section04",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Section 4    Wartime life")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Section05",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Section 5    Propaganda")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Section06",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Section 6    Casualties")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Section07",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Section 7    Personalities")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Section08",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Section 8    Refugees")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Section09",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Section 9    News")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Section10",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Section 10  Raids and occupation")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Section11",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Section 11  Joining in")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Section12",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Section 12  Christmas")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chronology",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Day by day chronology")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-942657b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Contents.vue
// module id = 63
// module chunks = 0